<div class="list-page vo-profile">
    <lokos-page-header [label]="headerLeader" [breadcrumbs]="breadcrumbs">
    </lokos-page-header>

    <lokos-card> </lokos-card>
</div>

<!-- <div class="resolution-wrapper" id="printAbleArea"> -->
<!-- shg-id-card.component.html -->
<div class="card-page-wrapper">
    <div class="id-card" id="printAbleArea">
        <!-- Header Bar -->
        <div class="card-header">
            <img
                src="assets/images/header-bg.png"
                alt=""
                class="header-bg"
                aria-hidden="true"
            />

            <div class="header-logos header-logos--left">
                <img
                    src="assets/images/ministry-logo-icon.svg"
                    alt="India Gov"
                    class="header-logo-img"
                />
                <div class="header-divider"></div>
                <img
                    src="assets/images/aajeevika-logo.svg"
                    alt="NRLM"
                    class="header-logo-img"
                />
            </div>

            <h1 class="card-title">{{ 'shgIDCard' | translate }}</h1>

            <div class="header-logos header-logos--right">
                <img
                    src="assets/images/digital-india.png"
                    alt="Digital India"
                    class="header-logo-img"
                />
                <!-- <img
                    src="assets/images/lokOsLogo.svg"
                    alt="Lokos"
                    class="header-logo-img"
                /> -->
            </div>
        </div>

        <!-- Card Body -->
        <div class="card-body">
            <!-- Left: Photo + Designation -->
            <div class="card-left">
                <div class="photo-frame">
                    <img
                        *ngIf="imageData && !imageError; else avatarPlaceholder"
                        [src]="imageData"
                        alt="Member Photo"
                        class="member-photo"
                    />

                    <ng-template #avatarPlaceholder>
                        <div class="avatar-placeholder">
                            <img src="https://cdn.lokos.in/assets/img/avatar.png" class="member-photo" alt="Member Image" />
                            <!-- <svg
                                viewBox="0 0 80 90"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <ellipse
                                    cx="40"
                                    cy="32"
                                    rx="20"
                                    ry="22"
                                    fill="#9eaab8"
                                />
                                <ellipse
                                    cx="40"
                                    cy="85"
                                    rx="34"
                                    ry="26"
                                    fill="#9eaab8"
                                />
                            </svg> -->
                        </div>
                    </ng-template>
                </div>
                <div class="designation-badge">
                    <span class="designation-text">{{ memDesignation }}</span>
                    <div class="designation-underline"></div>
                </div>
            </div>

            <!-- Right: Member Details -->
            <div class="card-right">
                <h2 class="member-name">{{ contName }}</h2>

                <div class="detail-list">
                    <div class="detail-row">
                        <span class="detail-label">{{
                            'fatherHusbandName' | translate
                        }}</span>
                        <span class="detail-sep">:</span>
                        <span class="detail-value">{{ relationName }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">{{
                            'dateOfBirth' | translate
                        }}</span>
                        <span class="detail-sep">:</span>
                        <span class="detail-value">{{
                            formatDate(memDob)
                        }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">{{
                            'shgMemberID' | translate
                        }}</span>
                        <span class="detail-sep">:</span>
                        <span class="detail-value">{{ contCode }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">{{
                            'shgName' | translate
                        }}</span>
                        <span class="detail-sep">:</span>
                        <span class="detail-value">{{ shgName }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">{{
                            'shgID' | translate
                        }}</span>
                        <span class="detail-sep">:</span>
                        <span class="detail-value">{{ shgCode }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">{{
                            'shgFormationDate' | translate
                        }}</span>
                        <span class="detail-sep">:</span>
                        <span class="detail-value">{{
                            formatDate(shgFormationDate)
                        }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">{{
                            'dateOfJoining' | translate
                        }}</span>
                        <span class="detail-sep">:</span>
                        <span class="detail-value">
                            @if (joiningDate) {
                                {{ joiningDate | date: 'dd-MM-yyyy' }}
                            }
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Card Footer -->
        <div class="card-footer">
            <div class="footer-left">
                <div class="footer-line"></div>
                <span class="footer-url">www.lokos.dord.gov.in</span>
            </div>
            <div class="footer-right">
                <div class="qr-frame">
                    <qrcode
                        [qrdata]="dataToString"
                        [width]="115"
                        [errorCorrectionLevel]="'M'"
                    ></qrcode>
                </div>
            </div>
        </div>

        <!-- Bottom-left Vector decoration -->
        <img
            src="assets/images/Vector.png"
            alt=""
            class="card-vector"
            aria-hidden="true"
        />
    </div>

    <!-- Action Buttons -->
    <div class="card-actions">
        <lokos-button
            [label]="'Download'"
            [type]="'primary'"
            (afterClick)="downloadPdf()"
        ></lokos-button>
        <lokos-button
            [label]="'Print'"
            [type]="'primary'"
            (afterClick)="printCard()"
        ></lokos-button>
    </div>
</div>
